import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class TransactionHistoryService {

    constructor(private _http: HttpClient) { }

    gettransactiondetails(data) {
        return this._http.post(environment.api_url + 'seller/transaction/history', data);
    }

}